import { AaGetcaptchaResp } from 'app/bff/models/aa/aaGetcaptcha';
import { MbGetinfoResp } from 'app/bff/models/mb/mbGetinfo';
import { Captcha, LoginInfo } from 'app/bff/models/mb/mbSignin';
import { FormValues as AuthFormValues } from 'app/features/Member/Register/Auth/types';

// State type
export interface AuthState {
  captcha?: AaGetcaptchaResp;
  memberProfile?: MbGetinfoResp;
  data?: AuthFormValues;
}
// ::: End

// Actions type constant
export const MEMBER_REGISTER_AUTH__FETCH_CAPTCHA = 'MEMBER_REGISTER_AUTH__FETCH_CAPTCHA';
export const MEMBER_REGISTER_AUTH__FETCH_CAPTCHA_DONE = 'MEMBER_REGISTER_AUTH__FETCH_CAPTCHA_DONE';
export const MEMBER_AUTH__REGISTER_MEMBER = 'MEMBER_AUTH__REGISTER_MEMBER';
export const MEMBER_REGISTER_AUTH__FETCH_MEMBER_PROFILE_DONE = 'MEMBER_REGISTER_AUTH__FETCH_MEMBER_PROFILE_DONE';
export const MEMBER_REGISTER_AUTH__SAVE_AUTH_PAGE_DATA = 'MEMBER_REGISTER_AUTH__SAVE_AUTH_PAGE_DATA';
export const MEMBER_REGISTER_AUTH__RESET_CACHE = 'MEMBER_REGISTER_AUTH__RESET_CACHE';
// ::: End

// Action creators type
export interface FetchCaptchaAction {
  type: typeof MEMBER_REGISTER_AUTH__FETCH_CAPTCHA;
}

export interface FetchCaptchaDoneAction {
  type: typeof MEMBER_REGISTER_AUTH__FETCH_CAPTCHA_DONE;
  payload: {
    response: AaGetcaptchaResp;
  };
}

export interface RegisterMemberAction {
  type: typeof MEMBER_AUTH__REGISTER_MEMBER;
  payload: {
    checkCaptchaArgs: Captcha;
    data: LoginInfo;
  };
}

export interface FetchMemberProfileDoneAction {
  type: typeof MEMBER_REGISTER_AUTH__FETCH_MEMBER_PROFILE_DONE;
  payload: {
    response: MbGetinfoResp;
  };
}

export interface SaveAuthPageDataAction {
  type: typeof MEMBER_REGISTER_AUTH__SAVE_AUTH_PAGE_DATA;
  payload: {
    data: AuthFormValues;
  };
}

export interface ResetCacheAction {
  type: typeof MEMBER_REGISTER_AUTH__RESET_CACHE;
}

export type AuthActions =
    FetchCaptchaAction
  | FetchCaptchaDoneAction
  | RegisterMemberAction
  | FetchMemberProfileDoneAction
  | SaveAuthPageDataAction
  | ResetCacheAction;
// ::: End
